<script>
export default {
  props: {
    value: {
      type: [Boolean, String, Number],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    choices: {
      type: Array,
      default: () => [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
  },
  emits: ['update', 'change'],
  methods: {
    addOnChange(choiceValue) {
      return {
        ...this.$attrs,
        onChange: (event) => {
          this.$emit('update', choiceValue)
          this.$emit('change', event)
        },
      }
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div v-if="label" :class="$style.label">{{ label }}</div>
    <label v-for="choice in choices" :key="choice.value">
      <div :class="$style.choice">
        <input
          :checked="value === choice.value"
          type="radio"
          v-bind="addOnChange(choice.value)"
        />{{ choice.label }}
      </div>
    </label>
  </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.container {
  margin-bottom: $size-grid-padding;

  input {
    display: inline-block;
    margin-left: $size-grid-padding * 0.25;
  }
}

.label {
  @extend %typography-label;

  color: $color-input-label;
}

.choice {
  color: $color-input-label;
  text-align: left;
  cursor: pointer;

  input {
    margin-right: $size-grid-padding * 0.4;
    cursor: pointer;
  }
}
</style>
